import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { LabelType } from '../../types';

@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelComponent {
  @ViewChild('label')
  private labelElement: ElementRef<HTMLSpanElement>;

  get shouldDisplayTooltip(): boolean {
    if (!this.hasTooltip || this.isEditingMode) {
      return;
    }

    return this.labelElement?.nativeElement.offsetWidth < this.labelElement?.nativeElement.scrollWidth;
  }

  get labelTemplate(): TemplateRef<any> {
    return this.name as TemplateRef<any>;
  }

  get isTemplatePassed(): boolean {
    return !!this.name && typeof this.name !== 'string' && typeof this.name !== 'number';
  }

  @Input()
  name: string | number | TemplateRef<any>;

  @Input()
  icon: string;

  @Input()
  type: LabelType = 'primary';

  @Input()
  isEditingMode = false;

  @Input()
  showIcons = true;

  @Input()
  hasTooltip = true;

  @Input()
  isHoverable = true;

  @Output()
  removeLabel = new EventEmitter<void>();
}
